import { render, staticRenderFns } from "./AfterActivation.vue?vue&type=template&id=45ccd49c&"
import script from "./AfterActivation.vue?vue&type=script&lang=js&"
export * from "./AfterActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports